import { FAMILY_PROFILE_COLORS } from './types/familyAccounts.types'

export const FamilyAccountsColorClasses = {
  [FAMILY_PROFILE_COLORS.VIOLET]: 'bg-task-numbers-gradient',
  [FAMILY_PROFILE_COLORS.BLUE]: 'bg-task-geometry-gradient',
  [FAMILY_PROFILE_COLORS.PINK]: 'bg-task-statistics-gradient',
  [FAMILY_PROFILE_COLORS.ORANGE]: 'bg-task-functions-gradient',
  [FAMILY_PROFILE_COLORS.YELLOW]: 'bg-task-proofs-gradient',
  [FAMILY_PROFILE_COLORS.GREEN]: 'bg-green-avocado',
  [FAMILY_PROFILE_COLORS.PURPLE]: 'bg-purple',
  [FAMILY_PROFILE_COLORS.GREY]: 'bg-black-light',
  [FAMILY_PROFILE_COLORS.DARK_PURPLE]: 'bg-purple-gdark',
  [FAMILY_PROFILE_COLORS.LIGHT_BLUE]: 'bg-blue-blueberry',
  [FAMILY_PROFILE_COLORS.INDIGO]: 'bg-blue-indigo',

  // === 40 entries, only using yellow, blue, pink, orange, green, purple variations ===
  [FAMILY_PROFILE_COLORS.PURPLE_LIGHT]: 'bg-purple/20',
  [FAMILY_PROFILE_COLORS.PURPLE_MEDIUM]: 'bg-purple/40',
  [FAMILY_PROFILE_COLORS.PURPLE_STANDARD]: 'bg-purple/50',
  [FAMILY_PROFILE_COLORS.PURPLE_DEEP]: 'bg-purple/60',
  [FAMILY_PROFILE_COLORS.PURPLE_DARK]: 'bg-purple/80',

  [FAMILY_PROFILE_COLORS.YELLOW_PASTEL]: 'bg-yellow/20',
  [FAMILY_PROFILE_COLORS.YELLOW_SOFT]: 'bg-yellow/30',
  [FAMILY_PROFILE_COLORS.YELLOW_STANDARD]: 'bg-yellow/60',
  [FAMILY_PROFILE_COLORS.YELLOW_WARM]: 'bg-yellow/70',
  [FAMILY_PROFILE_COLORS.YELLOW_GOLD]: 'bg-yellow/80',

  [FAMILY_PROFILE_COLORS.BLUE_LIGHT]: 'bg-blue/20',
  [FAMILY_PROFILE_COLORS.BLUE_SOFT]: 'bg-blue/30',
  [FAMILY_PROFILE_COLORS.BLUE_SKY]: 'bg-blue/40',
  [FAMILY_PROFILE_COLORS.BLUE_STANDARD]: 'bg-blue/60',
  [FAMILY_PROFILE_COLORS.BLUE_DEEP]: 'bg-blue/70',
  [FAMILY_PROFILE_COLORS.BLUE_NAVY]: 'bg-blue/80',
  [FAMILY_PROFILE_COLORS.BLUE_MIDNIGHT]: 'bg-blue/90',

  [FAMILY_PROFILE_COLORS.PINK_LIGHT]: 'bg-pink/40',
  [FAMILY_PROFILE_COLORS.PINK_SOFT]: 'bg-pink/50',
  [FAMILY_PROFILE_COLORS.PINK_STANDARD]: 'bg-pink/60',
  [FAMILY_PROFILE_COLORS.PINK_BRIGHT]: 'bg-pink/70',
  [FAMILY_PROFILE_COLORS.PINK_DEEP]: 'bg-pink/80',

  [FAMILY_PROFILE_COLORS.ORANGE_LIGHT]: 'bg-orange/40',
  [FAMILY_PROFILE_COLORS.ORANGE_SOFT]: 'bg-orange/50',
  [FAMILY_PROFILE_COLORS.ORANGE_STANDARD]: 'bg-orange/60',
  [FAMILY_PROFILE_COLORS.ORANGE_DEEP]: 'bg-orange/70',
  [FAMILY_PROFILE_COLORS.ORANGE_DARK]: 'bg-orange/80',

  [FAMILY_PROFILE_COLORS.GREEN_LIGHT]: 'bg-green/30',
  [FAMILY_PROFILE_COLORS.GREEN_SOFT]: 'bg-green/40',
  [FAMILY_PROFILE_COLORS.GREEN_STANDARD]: 'bg-green/50',
  [FAMILY_PROFILE_COLORS.GREEN_MEDIUM]: 'bg-green/60',
  [FAMILY_PROFILE_COLORS.GREEN_DEEP]: 'bg-green/70',
  [FAMILY_PROFILE_COLORS.GREEN_DARK]: 'bg-green/80',
}

export const profileColors = Array.from(new Set(Object.values(FAMILY_PROFILE_COLORS)))

export const MAX_LICENSES = 11
export const MAX_LICENSES_WITHOUT_ADMIN = 10
export const NOT_FAMILY_SUBSCRIPTION_ERROR_CODE = 'notFamilySubscription'
